import { Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { FormlyView } from '../../../ui/Data/FormlyView';
import { ListView } from '../../../ui/Data/ListView';
import { Art57Node } from '../../../ui/Node/Art57Node/Art57Node';
import { TreeNodeDrugIngredient } from '../../../ui/Node/Art57Node/Entity/TreeNodeDrugIngredient';
import { QueryResultNode } from '../../../ui/Node/QueryResultNode';
import { QueryNodeInBox } from '../../../ui/Node/WebTraderNode/Query/QueryNodeInBox';
import { ConfirmationService } from 'primeng/api';
import { LookupGetService } from '../../../service/lookup-service/lookup-get.service';
import { ResultList } from '../../../ui/Node/ListEntity/ResultList';
import { QueryNodeOutBox } from '../../../ui/Node/WebTraderNode/Query/QueryNodeOutBox';
import { WebtraderService } from '../../../service/webtrader-service/webtrader.service';
import { ResultListNodeOutbox } from '../../../ui/Node/WebTraderNode/ListEntity/ResultListNodeOutbox';
import { ResultListNodeInbox } from '../../../ui/Node/WebTraderNode/ListEntity/ResultListNodeInbox';
import { BulkUpdateList } from '../../../ui/Node/WebTraderNode/ListEntity/BulkUpdateList';
import { QueryNodeToEudravigilance } from '../../../ui/Node/WebTraderNode/Query/QueryNodeToEudravigilance';
import { ResultListNodeToEudravigilance } from '../../../ui/Node/WebTraderNode/ListEntity/ResultListNodeToEudravigilance';
import { ResultListNodeFromEudravigilance } from '../../../ui/Node/WebTraderNode/ListEntity/ResultListNodeFromEudravigilance';
import { QueryNodeFromEudravigilance } from '../../../ui/Node/WebTraderNode/Query/QueryNodeFromEudravigilance';

@Component({
  selector: 'app-detailed-webtrader-view',
  templateUrl: './detailed-webtrader-view.component.html',
  styleUrl: './detailed-webtrader-view.component.scss'
})
export class DetailedWebtraderViewComponent {
  @Input() selectedNode: any;
  @Output() modelChange = new EventEmitter<any>();
  @Output() selectedNodeChange = new EventEmitter<any>();
  @Output() goToSelectedNode = new EventEmitter<any>();
  @Output() buttonAction = new EventEmitter<any>();
  @Output() removeNode = new EventEmitter<any>();
  loading:boolean=false;


  constructor (private injector: Injector,
               private confirmationService: ConfirmationService
  ){   
    this.injector.get(WebtraderService).loading.subscribe(value=>this.loading=value);
  }



  onFormlyDetailedModelChange(event: any) {

    this.modelChange.emit(event);
  }

  onListDetailedModelChange(event: any) {
    this.modelChange.emit(event);
  } 

 onButtonAction(event: any){
  this.buttonAction.emit(event);
 }

 onSelectedNodeChange(selectedNode:Art57Node){
  this.goToSelectedNode.emit(selectedNode);
 }

 getXML(node: any): Promise<string>{
  return new Promise((resolve, reject) => {
    let lookupName: string = '';
    if(this.selectedNode instanceof QueryNodeInBox ||
      this.selectedNode instanceof QueryNodeToEudravigilance ||
      this.selectedNode.parent instanceof ResultListNodeInbox ||
      this.selectedNode.parent instanceof ResultListNodeToEudravigilance
      )
    {
      lookupName = 'inboundmessage';
    } if(this.selectedNode instanceof QueryNodeOutBox ||
      this.selectedNode instanceof QueryNodeFromEudravigilance ||
      this.selectedNode.parent instanceof ResultListNodeOutbox ||      
      this.selectedNode.parent instanceof ResultListNodeFromEudravigilance)
    {
      lookupName = 'outboundmessage';
    }
    this.injector.get(LookupGetService).get(lookupName,node.id).subscribe({
      next: data =>{
        resolve(data.name);
      },
      error: () => {
        reject('');
      }
      
    });
  })

 }

 onItemFinderDoubleClick(item: any) {
  const fileName = item.code;
  
  this.getXML(item).then(data => {

    const link = document.createElement('a');
    let url: string;

      url = URL.createObjectURL(new Blob([data], { type: 'text/xml' }));

      link.href = url;
      if (fileName.endsWith('.zip')) {
        link.download = fileName.slice(0, -4) + '.xml'; 
      }else{
        link.download = fileName;
      }
      

      this.confirmationService.confirm({
        header: 'Message information',
        message: "Click on the link below to review the XML message.<br><br><a href='" + link.href + "' target='_blank'>" + link.download + "</a>",
        icon: 'pi pi-question-circle',
        acceptLabel: 'Download',
        rejectLabel: 'Close',
        accept: () => {
          link.click();
          URL.revokeObjectURL(url);
        },
        reject: () => {
          URL.revokeObjectURL(url);
        }
      });
    
  });     
  
        
}

 onRemoveNode(selectedNode: Art57Node) {
  this.removeNode.emit(selectedNode);
 }

 isInstanceOfFormlyView(): boolean {
  return (this.selectedNode.data instanceof FormlyView) && (!this.isInstanceOfFormlyDrugIngredientsFormlyView());
}

  isInstanceOfFormlyDrugIngredientsFormlyView(): boolean {
    return (this.selectedNode instanceof TreeNodeDrugIngredient);
  }

  isInstanceOfListView(): boolean {
    return this.selectedNode.data instanceof ListView ||
           this.selectedNode instanceof ResultList;
  }

  isQueryListView(): boolean {
    return (this.selectedNode instanceof QueryResultNode) 
    || (this.selectedNode instanceof QueryNodeInBox)
    || (this.selectedNode instanceof QueryNodeOutBox)
    || (this.selectedNode instanceof QueryNodeToEudravigilance
    || (this.selectedNode instanceof QueryNodeFromEudravigilance)
    )
    ;
  }

  isBulkExport():boolean{
    return this.selectedNode instanceof BulkUpdateList;
  }
}
